import { Element } from 'ltx';

export abstract class AbstractStanzaBuilder {

    abstract toStanza(): Element;

}
